import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const FormWrapper = styled.form``;

const textareaMobile = media.phone`
  min-height: 62px;
  line-height: 22px;
`;

export const ControlGroup = styled.fieldset`
  margin: 0;
  padding: 0;
  border: 0;
  color: #292a2b;

  input {
    margin-bottom: 18px;
  }

  input,
  textarea {
    color: inherit;

    &::-webkit-input-placeholder {
      color: #919eaa;
    }
  }
  textarea {
    min-height: auto;
    height: 40px;
    line-height: 1;
    resize: none;
    padding-top: 10px;
    padding-bottom: 10px;
    ${textareaMobile};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: #919eaa;
    `}
`;
